import PropTypes from 'prop-types';

export const richtextShape = {
  text: PropTypes.string,
  html: PropTypes.string,
};

export const richtextType = PropTypes.shape(richtextShape);
